import { createFileRoute } from '@tanstack/react-router';
import { TemplatesPage } from '@/features/messaging/pages/templates-page';

export const Route = createFileRoute('/_app/messages/templates')({ component: TemplatesPage });
